(function () {
  var gree_app_swiper1 = new Swiper('.gree-app .swiper-step1', {
    keyboard: { enabled: true },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next.m1',
      prevEl: '.swiper-button-prev.m1',
    },
    breakpoints: {
      1000: {
        navigation: {
          nextEl: '.gree-app .swiper-step1 .swiper-button-next',
          prevEl: '.gree-app .swiper-step1 .swiper-button-prev',
        },
      },
    },
  });

  var gree_app_swiper11 = new Swiper('.gree-app .inner-container1', {
    nested: true,
    keyboard: { enabled: true },
    //resistanceRatio: 0,
    slidesPerView: 'auto',
    freeMode: true,
    navigation: {
      nextEl: '.gree-app .inner-container1 .swiper-button-next',
      prevEl: '.gree-app .inner-container1 .swiper-button-prev',
    },
  });

  var gree_app_swiper2 = new Swiper('.gree-app .swiper-step2', {
    keyboard: { enabled: true },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next.m2',
      prevEl: '.swiper-button-prev.m2',
    },
    breakpoints: {
      1000: {
        navigation: {
          nextEl: '.gree-app .swiper-step2 .swiper-button-next',
          prevEl: '.gree-app .swiper-step2 .swiper-button-prev',
        },
      },
    },
  });
  var gree_app_swiper22 = new Swiper('.gree-app .inner-container2', {
    slidesPerView: 'auto',
    nested: true,
    freeMode: true,
    keyboard: { enabled: true },
  });

  if (window.screen.width <= 700) {
    var benefitSwiper = new Swiper('.gree-app .benefits-imgs', {
      slidesPerView: 1,
      keyboard: { enabled: true },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      // freeMode: true,
      breakpoints: {
        700: {
          slidesPerView: 'auto',
        },
      },
    });
  }
})();